'use strict';

var cookies = require('js-cookie');
var logger = require('../utils/logger');

module.exports = {
    init: function () {
		// NGX is setup by the 'x.wayin.com' script tags added by editors via the CMS
		// If the script tag is not present then we don't push the permutive id to marigold
		if (!window.NGX) {
			return;
		}

		const permutiveIDCookie = cookies.get('permutive-id');
		if (!permutiveIDCookie) {
			logger.warn('Marigold: Failed to set customer id - No permutive ID cookie');
			return;
		}

		window.NGX.api('event:listen', 'embed:api:ready', () => {
			window.NGX.api('form:set:customerid', permutiveIDCookie);
			logger.info('Marigold: Set customer id to: ' + permutiveIDCookie);
		});
	}
};